// src/features/sales/components/DistinctSaleRow.js

// Formatter: 2-decimal general number, with thousand separators
const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "—";

  const num = Number(value);
  if (Number.isNaN(num)) return "—";

  return num.toLocaleString("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Qty formatter: no decimals
const formatQty = (value) => {
  if (value === null || value === undefined || value === "") return "—";

  const num = Number(value);
  if (Number.isNaN(num)) return "—";

  return num.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export default function DistinctSaleRow({ sale }) {
  return (
    <tr className="hover:bg-gray-50/40">
      <td className="px-6 py-3 text-sm text-gray-600">
        {sale.main_company || "—"}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {sale.yearMonth || "—"}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
        {sale.transaction_count ?? "—"}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
        {formatQty(sale.quantity)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
        {formatNumber(sale.sales)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
        {formatNumber(sale.net_sales)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
        {formatNumber(sale.ppn)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
        {formatNumber(sale.debet)}
      </td>
    </tr>
  );
}
